module.exports = __webpack_public_path__ + "static/media/female.5474f684.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/avatars/female.png
 ** module id = 64
 ** module chunks = 0
 **/